// extracted by mini-css-extract-plugin
export default {"cell":"_64zC01","one-column-layout":"qF_iVU","oneColumnLayout":"qF_iVU","two-column-layout":"jEdk5H","twoColumnLayout":"jEdk5H"};